module.exports = __webpack_public_path__ + "static/media/panWrong.21fb1e69.png";